/**
 * @generated SignedSource<<6dbff3455bf29c0deb0ff138210ef43b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ArtistCharts_artist$data = {
  readonly instagramProfile: {
    readonly instagramProfileData: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly date: any;
          readonly followers: number | null;
        } | null;
      } | null>;
    };
  } | null;
  readonly spotifyProfile: {
    readonly spotifyProfileData: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly date: any;
          readonly listeners: number | null;
        } | null;
      } | null>;
    };
  } | null;
  readonly tiktokProfile: {
    readonly tiktokProfileData: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly date: any;
          readonly followerCount: number | null;
        } | null;
      } | null>;
    };
    readonly tiktokSounds: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly data: ReadonlyArray<{
            readonly date: any;
            readonly value: number;
          }>;
        } | null;
      } | null>;
    };
  } | null;
  readonly " $fragmentType": "ArtistCharts_artist";
};
export type ArtistCharts_artist$key = {
  readonly " $data"?: ArtistCharts_artist$data;
  readonly " $fragmentSpreads": FragmentRefs<"ArtistCharts_artist">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "date",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ArtistCharts_artist",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ProfileNode",
      "kind": "LinkedField",
      "name": "spotifyProfile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "SpotifyProfileDataNodeConnection",
          "kind": "LinkedField",
          "name": "spotifyProfileData",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "SpotifyProfileDataNodeEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "SpotifyProfileDataNode",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "listeners",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ProfileNode",
      "kind": "LinkedField",
      "name": "instagramProfile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "InstagramProfileDataNodeConnection",
          "kind": "LinkedField",
          "name": "instagramProfileData",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "InstagramProfileDataNodeEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "InstagramProfileDataNode",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "followers",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ProfileNode",
      "kind": "LinkedField",
      "name": "tiktokProfile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "TikTokProfileDataNodeConnection",
          "kind": "LinkedField",
          "name": "tiktokProfileData",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "TikTokProfileDataNodeEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "TikTokProfileDataNode",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "followerCount",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "TikTokSoundNodeConnection",
          "kind": "LinkedField",
          "name": "tiktokSounds",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "TikTokSoundNodeEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "TikTokSoundNode",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "TikTokSoundDataNode",
                      "kind": "LinkedField",
                      "name": "data",
                      "plural": true,
                      "selections": [
                        (v0/*: any*/),
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "value",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ArtistNode",
  "abstractKey": null
};
})();

(node as any).hash = "aa3c538b625a2c29650e462958298af4";

export default node;
